<template>
    <div class="industry_blacklist_content">
		<div class="font_bold text_left">
			{{ $t("customRating.industryBlacklist.description") }}
		</div>
		<div class="flex flex_items_center">
			<a class="pointer" @click="collapseAll()">
				{{ $t("common.collapseAll")}}
			</a>
			<a class="pointer margin_l" @click="expandAll()">
				{{ $t("common.expandAll")}}
			</a>
			<md-switch v-model="showOnlyChecked" class="margin_l">
				{{ $t("customRating.industryBlacklist.showOnlyChecked")}}
			</md-switch>
		</div>
		<TreeCheckableList class="industry_blacklist_tree"
						   v-model="blacklistedNaceCodes"
						   :api="getIndustryTreeList"
						   options-value-field="data.naceCode"
						   :options-display-getter="formatIndustryOption"
						   :search-allow="true"
						   :show-only-checked="showOnlyChecked"
						   :width-max-content="true"
						   ref="tree"
		></TreeCheckableList>
		<md-button class="md-primary margin_top" @click="save">
			{{ $t("common.save") }}
		</md-button>
	</div>
</template>

<script>
import {formatAsIndustryText} from "@/common/format";
import {commonApi} from "@/common/api/commonApi";
import {industryBlacklistApi} from "@/common/api/industryBlacklistApi";
import TreeCheckableList from "@/components/templates/common/TreeCheckableList.vue";

export default {
	components: { TreeCheckableList },
	data() {
		return {
			blacklistedNaceCodes: [],
			showOnlyChecked: false,
		};
	},
	created() {
		this.loadBlacklist();
	},
	methods: {
		getIndustryTreeList() {
			return commonApi.getIndustryTreeList();
		},
		loadBlacklist() {
			industryBlacklistApi.inspection.getBlacklisted()
				.then(res => this.blacklistedNaceCodes = res.map(industry => industry.naceCode))
				.catch(this.toast);
		},
		formatIndustryOption(option) {
			return formatAsIndustryText(option.data.naceCode);
		},
		expandAll() {
			this.$refs.tree.expandAll();
		},
		collapseAll() {
			this.$refs.tree.collapseAll();
		},
		save() {
			industryBlacklistApi.operation.save(this.blacklistedNaceCodes)
				.then(this.toastSuccess)
				.catch(this.toast);
		}
	},
}
</script>

<style lang="scss" scoped>
.industry_blacklist_content {
	display: flex;
	flex-direction: column;

	.industry_blacklist_tree {
		overflow: hidden;
		max-height: calc(100vh - 300px);
	}
	.md-button {
		align-self: flex-start;
		min-height: 43px;
	}
}

</style>